
import { useLanguage } from "@/contexts/LanguageContext";

interface VerificationEmailDisplayProps {
  email: string;
}

export const VerificationEmailDisplay = ({ email }: VerificationEmailDisplayProps) => {
  const { t } = useLanguage();
  
  if (!email) return null;
  
  return (
    <div className="mb-4 p-3 bg-primary/5 rounded-md text-sm">
      {t('verificationEmailSentTo') || 'Verification code sent to'}: <strong>{email}</strong>
    </div>
  );
};
